import type { Locale } from '@susu/headless-commerce/config/locale'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import type { PageType } from '@susu/headless-commerce/types/PageType'
import { trackEvent } from '@susu/headless-commerce/utils/tracking/tracking'

import { baseURL } from '@susu/headless-commerce/config/config'
import {
  getLocationIdValue,
  getURLTrackingValue,
} from '@susu/headless-commerce/features/configurator/utils/getURLTrackingValue'

export const trackNextStepClickEvent = async ({
  categoryStep,
  country,
  locale,
  pageType,
}: {
  categoryStep: string
  country: CountryConfiguration
  locale: Locale
  pageType: PageType
}) => {
  await trackEvent({
    segment: {
      event: 'nextStepClicked',
      enrichProps: {
        country,
        locale,
      },
      properties: {
        eventLabel: '',
        eventCategory: 'configurator_interactions',
        eventLocation: `configurator_${categoryStep}`,
        locationId: getLocationIdValue(new URL(baseURL()), categoryStep),
        pageType: pageType,
        url: getURLTrackingValue(new URL(baseURL()), categoryStep),
      },
    },
  })
}
